import { Component, Input } from '@angular/core';

/**
 * Sticky toolbar a page renders below the shell's content edge, for a page title plus actions.
 *
 * The dashboard version had a `fixed` mode driven by its layout config; the CSS that positioned it
 * (and offset the content) is not part of this layout, so the toolbar is always full width here.
 */
@Component({
  selector: 'rms-secondary-toolbar',
  template: `
    <div class="secondary-toolbar-placeholder">&nbsp;</div>

    <div class="secondary-toolbar w-full py-1 z-40 border-t flex">
      <div class="px-6 flex items-center flex-auto">
        @if (current) {
          <h1
            class="subheading-2 font-medium m-0 ltr:pr-3 rtl:pl-3 ltr:border-r rtl:border-l ltr:mr-3 rtl:ml-3 flex-none">
            {{ current }}
          </h1>
        }

        <ng-content />
      </div>
    </div>
  `,
  styleUrls: ['./secondary-toolbar.component.scss'],
})
export class SecondaryToolbarComponent {
  @Input() public current?: string;
}
